import { system } from "styled-system";
export const gap = system({
    gap: {
        property: "gap",
    },
    rowGap: {
        property: "row-gap",
    },
    columnGap: {
        property: "column-gap",
    },
});
